import { View, SxProp } from 'dripsy';
import React from 'react';
import { TextSmall } from '../typography';

export interface UniNotesProps {
  title: string;
  paragraphs: Array<string>;
  sx?: SxProp;
  isList?: boolean;
}

export const UniNotes: React.FC<UniNotesProps> = (props) => {
  const { title, paragraphs, isList, sx } = props;
  return (
    <View sx={sx}>
      <TextSmall secondary semiBold label>
        {title}
      </TextSmall>
      {paragraphs.map((paragraph, i) => (
        <View
          key={i}
          sx={{
            flexDirection: 'row'
          }}>
          {isList && (
            <TextSmall secondary sx={{ mr: 5 }}>
              {'\u2022'}
            </TextSmall>
          )}
          <TextSmall key={i} secondary>
            {paragraph}
          </TextSmall>
        </View>
      ))}
    </View>
  );
};
